export default __webpack_public_path__ + "static/media/ic_video.6a9d73c4.svg";